import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import Fa_IR from 'antd/es/locale/fa_IR'
import {root as baseRoot} from "./utilis/defaults/URL";
import {BrowserRouter} from "react-router-dom";
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <ConfigProvider direction="rtl" locale={Fa_IR}>
          <BrowserRouter  basename={baseRoot}>
              <App />
          </BrowserRouter>

      </ConfigProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
